import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FieldTimeOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldTimeOutlined";
import AntdIcon from "../components/AntdIcon";
var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldTimeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FieldTimeOutlined.displayName = 'FieldTimeOutlined';
}
export default /*#__PURE__*/React.forwardRef(FieldTimeOutlined);